// MainButtonSite
import React from 'react';

const MainButtonSite = (props) => {
    return (
        <button
            type="button"
            className={!props.medium ? "mainButtonSite" : "mainButtonSite medium"}
            onClick={props.onClick}
            disabled={props.disabled}
        >
            {props.icon ? props.icon : null}
            <span>{props.text}</span>
        </button>
    );
};

export default MainButtonSite;